export default "/assets/images/mila-filters-boxes.png?417c852671280f6e4f71c99f1f2ee729";